//Special type of dashboard to show all the metrics
define('app/dashboard/panels/MetricDashboardPanel',['require','./DashboardPanel','../MetricEntitiesGridView','hbs!./MetricDashboardPanel.hbs'],function(require) {

	'use strict';
	var DashboardPanel = require('./DashboardPanel'),
		MetricEntitiesGridView = require('../MetricEntitiesGridView');

	return DashboardPanel.extend({
		template: require('hbs!./MetricDashboardPanel.hbs'),

		addViews: function() {
			//'my reports' tab
			this.gridMy = new MetricEntitiesGridView({
				model: this.model,
				items: this.model.reportCollection(),
				itemType: 'report',
				filter: this.gridFilterMyReports
			});
			this.$('.metrics').find('.entities-grid-container').empty();
			this.$('.metrics').find('.entities-grid-container').append(this.gridMy.render().el);
		},

		gridFilterMyReports: function(entity) {
			// filter out spd reports and n0n-widgets
			if (entity.getReportType() === 'METRIC') {
				return true;
			}
			return false;
		}
	});
});

